<template>
    <div class="redisWarningSearch">
        <Row :gutter="4">
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="alertRuleSearchKey" :placeholder="$t('alarms.common.filterByAlertRuleName')" @on-search="searchAlertRule()"/>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableRedisWarning from '../redis/TableRedisWarning'
    var tableRedisWarning = TableRedisWarning;
    export default {
        name: 'RedisWarningSearch',
        data () {
            return {
                alertRuleSearchKey:'',
                alertRuleSearchName:''
            }
        },
        methods: {
            // 按规则名称搜索
            searchAlertRule: function(){
                eventBus.$emit('alertRuleSearchName', this.alertRuleSearchKey);
                tableRedisWarning.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .redisWarningSearch
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/elasticache/redis/RedisWarningSearch.vue